import bgImage from "../../../images/home/young-person-with-anxiety-talking-specialist.jpg";
import "./SubHeader.css";

const SubHeader = ({ title, subtitle }) => {
  return (
    <section
      className="subheader"
      style={{
        width: "100%",
        height: "45vh",
        padding: "100px 0 100px 0",
        backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay"></div>
      <div className="container position-relative">
        <div className="row">
          <div className="col-md-12">
            <div className="mb-4 section-title text-center">
              <h2 className="text-white text-uppercase">{title}</h2>
              <p className="text-white m-0">{subtitle && subtitle}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubHeader;
